/* ==========================================================================
   BELORA — SKIMS PURE · BELORA FIT
   Tablo sunucuda basılır. Bu dosya yalnız "Bedenimi Bul" hesabını yapar ve
   sonucu GERÇEK varyant seçicisine uygular — ikinci bir beden state'i yoktur.
   Öneri ürünün kendi `size_profiles` verisinden gelir; hiçbir eşik burada
   uydurulmaz, eksik veri tahminle doldurulmaz.
   ========================================================================== */

(function () {
  'use strict';

  /* Panel artık bir modal ve referansın beden rehberi gibi ANİ açılıp kapanıyor:
     ölçümde panelde de atalarında da transition 0s / animation none çıktı
     (tmp-sk-guide). Prestige'in x-modal'ı ise >=sm'de 200ms soluyor, altında
     300ms alt sayfa kaydırıyor. Bu yüzden BU örneğe dialog taban sınıfının
     kendi sıfır süreli kontrolleri veriliyor — motorun kendi nesnesi olduğu
     için .finish() ve .finished korunuyor. Zoom ile aynı teknik; diğer
     modallar temanın davranışını korur. */
  function instant() {
    var el = document.querySelector('x-modal.sk-size');
    if (!el || el._skNoMotion) return;
    var MC = window.customElements && window.customElements.get('x-modal');
    var base = MC && Object.getPrototypeOf(MC.prototype);
    if (!base || typeof base.createEnterAnimationControls !== 'function') return;
    el.createEnterAnimationControls = base.createEnterAnimationControls;
    el.createLeaveAnimationControls = base.createLeaveAnimationControls;
    el._skNoMotion = true;
  }
  instant();
  /* x-modal may not be defined yet when this file runs, so try again on the way
     in — the capture phase lands before the dialog engine opens the panel. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.sk-opt__guide')) instant();
  }, true);

  var form = document.querySelector('[data-sk-finder]');
  if (!form) return;

  /* Bind BEFORE any early return. This is a real <form> so Enter submits it,
     but its action is the product URL — if the script bailed out first, a
     submit reloaded the page and silently lost the customer's input. */
  form.addEventListener('submit', function (e) { e.preventDefault(); });

  var panel = form.closest('x-modal') || form.closest('x-drawer');
  var blob = panel && panel.querySelector('[data-sk-size-profiles]');
  var profiles = [];
  try {
    var parsed = JSON.parse((blob && blob.textContent) || '[]');
    profiles = Array.isArray(parsed) ? parsed : [];
  } catch (e) { profiles = []; }

  var resultBox = form.querySelector('[data-sk-finder-result]');
  var sizeOut = form.querySelector('[data-sk-finder-size]');
  var hintOut = form.querySelector('[data-sk-finder-hint]');
  var errOut = form.querySelector('[data-sk-finder-error]');
  var applyBtn = form.querySelector('[data-sk-finder-apply]');
  var position = form.getAttribute('data-option-position');
  var applyDefault = applyBtn ? applyBtn.textContent.trim() : '';
  var recommended = null;

  function heightColumns() {
    var keys = Object.keys(profiles[0].weight_by_height || {});
    return keys.map(Number).filter(function (n) { return !isNaN(n); })
      .sort(function (a, b) { return a - b; });
  }

  /* The source's height columns are discrete (155/160/165/170/175). A height
     between them uses the nearest column, and the customer is TOLD that —
     it is never silently rounded. */
  function nearestColumn(h) {
    var cols = heightColumns();
    if (!cols.length) return null;
    return cols.reduce(function (best, c) {
      return Math.abs(c - h) < Math.abs(best - h) ? c : best;
    }, cols[0]);
  }

  function recommend(height, weight) {
    var col = nearestColumn(height);
    if (col === null) return null;
    var key = String(col);
    for (var i = 0; i < profiles.length; i++) {
      var r = profiles[i].weight_by_height && profiles[i].weight_by_height[key];
      if (!r) continue;
      var min = r.min == null ? -Infinity : Number(r.min);
      var max = r.max == null ? Infinity : Number(r.max);
      /* Bands share their boundaries in the source (…-52, 52-60), so the lower
         bound is exclusive — otherwise two sizes would claim the same weight. */
      if (weight > min && weight <= max) {
        return { label: profiles[i].label, column: col, note: profiles[i].note || '' };
      }
    }
    /* Outside every band: return the edge size and SAY so rather than
       inventing a range. */
    var first = profiles[0];
    var last = profiles[profiles.length - 1];
    var lowMax = first.weight_by_height && first.weight_by_height[key] && first.weight_by_height[key].max;
    if (lowMax != null && weight <= Number(lowMax)) {
      return { label: first.label, column: col, edge: 'low', note: first.note || '' };
    }
    return { label: last.label, column: col, edge: 'high', note: last.note || '' };
  }

  function findSizeInput(label) {
    var scope = document.querySelector('[data-sk-option][data-option-position="' + position + '"]')
      || document.querySelector('[data-sk-choice]');
    if (!scope) return null;
    var labels = scope.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if ((labels[i].textContent || '').trim().toUpperCase() === String(label).trim().toUpperCase()) {
        return labels[i].previousElementSibling;
      }
    }
    return null;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    errOut.hidden = true;

    if (!profiles.length) {
      errOut.textContent = 'Bu ürün için beden verisi yüklenemedi.';
      errOut.hidden = false;
      resultBox.hidden = true;
      return;
    }

    var fd = new FormData(form);
    var height = Number(fd.get('height'));
    var weight = Number(fd.get('weight'));

    if (!height || !weight || height < 120 || height > 210 || weight < 30 || weight > 200) {
      errOut.textContent = 'Lütfen geçerli bir boy (120-210 cm) ve kilo (30-200 kg) girin.';
      errOut.hidden = false;
      resultBox.hidden = true;
      return;
    }

    var rec = recommend(height, weight);
    if (!rec) {
      errOut.textContent = 'Bu ürün için beden verisi bulunamadı.';
      errOut.hidden = false;
      return;
    }
    recommended = rec.label;
    sizeOut.textContent = rec.label;

    var hints = [];
    if (rec.column !== height) hints.push(rec.column + ' cm sütununa göre hesaplandı.');
    if (rec.edge === 'low') hints.push('Girdiğiniz kilo tablonun altında; en küçük beden öneriliyor.');
    if (rec.edge === 'high') hints.push('Girdiğiniz kilo tablonun üstünde; en büyük beden öneriliyor.');
    if (rec.note) hints.push(rec.note);
    hintOut.textContent = hints.join(' ');
    hintOut.hidden = hints.length === 0;

    /* Never hand back a dead button: check the recommended size actually
       exists on THIS product and whether it is in stock. */
    var input = findSizeInput(rec.label);
    var lbl = input && input.nextElementSibling;
    if (!input) {
      applyBtn.disabled = true;
      applyBtn.textContent = 'Bu beden bu üründe yok';
    } else if (lbl && lbl.classList.contains('is-unavailable')) {
      applyBtn.disabled = false;
      applyBtn.textContent = 'Yine de seç (tükendi)';
    } else {
      applyBtn.disabled = false;
      applyBtn.textContent = applyDefault;
    }
    resultBox.hidden = false;
  });

  applyBtn.addEventListener('click', function () {
    if (!recommended || applyBtn.disabled) return;
    var input = findSizeInput(recommended);
    if (!input) return;
    /* Click the REAL radio. Prestige's variant-picker takes over from here, so
       price, availability, media, URL and the ATC all stay in sync by
       themselves — there is no second source of truth. */
    input.click();
    if (panel && typeof panel.hide === 'function') panel.hide();
  });
})();
